import { subMonths, subWeeks } from "date-fns"
import { dateToYYYYMMDD } from "./conversions"
import { getExceptionByFile, getExceptionFiles, getFileById, getFileStatus } from "./files"
import { getFitDocMetafilter, getFitDocToken, getFitDocTypes } from "./token"
import axios from "axios"

function mergeDossiers(dossiers) {

    const mergedDossiers = dossiers.flat();
    const noDuplicateDossiers = []

    mergedDossiers.forEach(dossier => {
        if(!dossier) return;
        const otherDossiersSameId = mergedDossiers.filter(d => d?.dossierentityid === dossier?.dossierentityid);

        if (otherDossiersSameId.length === 1) {
            noDuplicateDossiers.push(dossier);
        }

        if (otherDossiersSameId.length > 1) {
            const mergedDocuments = [...new Set(otherDossiersSameId.map(d => d.documents).flat())];
            const mergedMetadata = [...new Set(otherDossiersSameId.map(d => d.metadata).flat())];
            const mergedNations = [...new Set(otherDossiersSameId.map(d => d.nations).flat())];
            const mergedRemarkOnClose = otherDossiersSameId.find(d => d.remarkonclose)?.remarkonclose || '';
            const mergedExtendedDescription = otherDossiersSameId.find(d => d.extendeddescription)?.extendeddescription || '';
            const mergedDescription = otherDossiersSameId.find(d => d.description)?.description || '';
            const mergedOwner = otherDossiersSameId.find(d => d.owner)?.owner || '';
            const mergedDefaultDocType = otherDossiersSameId.find(d => d.defaultdoctype)?.defaultdoctype || '';
            const mergedDeadline = otherDossiersSameId.find(d => d.deadline)?.deadline || '';
            const mergedInactive = otherDossiersSameId.find(d => d.inactive)?.inactive || false;
            const mergedCreationDate = otherDossiersSameId.find(d => d.creationdate)?.creationdate || '';
            const mergedReminderDate = otherDossiersSameId.find(d => d.reminderdate)?.reminderdate || '';


            noDuplicateDossiers.push({
                ...dossier,
                documents: mergedDocuments,
                metadata: mergedMetadata,
                nations: mergedNations,
                remarkonclose: mergedRemarkOnClose,
                extendeddescription: mergedExtendedDescription,
                description: mergedDescription,
                owner: mergedOwner,
                defaultdoctype: mergedDefaultDocType,
                deadline: mergedDeadline,
                inactive: mergedInactive,
                creationdate: mergedCreationDate,
                reminderdate: mergedReminderDate
            });
        }
    });

    return noDuplicateDossiers
}

export const getFilesNew = async (user, startdate, enddate) => {

    if(!startdate){
        if(user.role.toString() === "1"){
            startdate = dateToYYYYMMDD(subWeeks(new Date(), 1))
        }
        else {
            startdate = dateToYYYYMMDD(subMonths(new Date(), 1))
        }
    }
    if(!enddate){
        enddate = dateToYYYYMMDD(new Date())
    }

    const token = await getFitDocToken(user);
    const types = await getFitDocTypes();
    const metafilter = await getFitDocMetafilter(user);


    const promises = await Promise.all(metafilter.map((metafilter) => axios.get(`${process.env.REACT_APP_SERVER_LINK}dossiers?token=${token}&types=${types.join(";")}&metafilter=${metafilter}&startdate=${startdate}&enddate=${enddate}`)))

    const result = await Promise.all(promises.map(p => p.data).map(i => i.object).filter(a => a !== null || !Array.isArray(a)));

    const dossiers = mergeDossiers(result) ?? [];
    if(!Array.isArray(dossiers)){return []}


    // const { data:f } = await axios.get(`${process.env.REACT_APP_SERVER_LINK}dossiers?token=${token}&types=${types.join(";")}&metafilter=${metafilter}&startdate=${startdate}&enddate=${enddate}`)
    
    
    try {

            
            if(parseFloat(user.role) !== 1){
                console.log("Getting file status...")
                let completeJSON = await getFileStatus(JSON.parse(window.sessionStorage.getItem("user_data")))
                
                let files = dossiers;
                
                let new_files = []
                //Filtered exceptions
                console.log("Filtering expections...")
                let filtered_exceptions = await filteredExceptions(files, user, completeJSON.incomplete);
                new_files = filtered_exceptions;


                //Filtered files
                console.log("Filtering files...")
                let filtered_files = await filteredFiles(dossiers, user, completeJSON.incomplete);

                


                let filteredArr_files = filtered_files.filter(obj => !filtered_exceptions.some(item => item.dossierentityid === obj.dossierentityid));

                //Filter by rights
                //const filtered_rights = filterByRights(filteredArr_files, user);
                const filtered_rights = filteredArr_files

                // console.log(filtered_rights);
                // console.log(filteredArr_files)

                let newArray = new_files.concat(filtered_rights);
                
                return newArray;
            }
            else {
                //User is admin, no filtering required
                return dossiers;
            }

    } catch (error) {
        console.error("Error during getting files")
        console.log(error)
        return []
    }
}

const filterByRights = (files, user) => {
    const enabledViewDoctypes = user.userright.doctypesrights.filter(i=>i.view===true).map(i => i.doctype);

    for(const file of files) {
        if(file.documents && Array.isArray(file.documents)){
            file.documents = file.documents.filter(i=>(i.document && enabledViewDoctypes.includes(i.document.doctype) && !i.document.doctype.includes('AFAC')))
        }
    }

    return files;
}

export const filteredExceptions = async (files, user, incompleteArray) => {
    let result = []

    let exc = await getExceptionFiles();
    let exceptions = exc.filter(num => {
        for (let i = 0; i < files.length; i++) {
          if (parseFloat(files[i].dossierentityid) === parseFloat(num)) {
            return true;
          }
        }
        return false;
    });

    if(exceptions.length === 0){
        return result;
    }

    let promise = new Promise((resolve, reject) => {
        exceptions.forEach(async (exception, index, array) => {
            let settings_exception = await getExceptionByFile(exception)
            let file_exception = await getFileById(exception)
    
            if(file_exception[0]){
                if(Array.isArray(file_exception[0].documents)){
                    let indexesToRemove = []
                    file_exception[0].documents.forEach(document => {
                        if(document.document){
                            let type = document.document.doctype;
                            let users = settings_exception.doctypes.find(object => object.doctype === type && !object.users.includes(parseFloat(user.role)))
                            if(users){
                                //Remove from documents
                                indexesToRemove.push(file_exception[0].documents.findIndex(v => v.document && v.document.doctype === users.doctype))           
                            }      
                        }                       
                    });
    
                    function removeObjectsByIndex(objectsArray, indexesArray) {
                        return objectsArray.filter((object, index) => !indexesArray.includes(index));
                    }
    
                    file_exception[0].documents = removeObjectsByIndex(file_exception[0].documents, indexesToRemove);

                    //Check if file is complete
                    if(!incompleteArray.includes(parseFloat(file_exception[0].state))){
                        result.push(file_exception[0])
                    }  
                }
            }

            if (index === array.length -1) resolve();
        })
    })
    
    return promise.then(()=>{
        return result;
    })
}

export const filteredFiles = async (files, user, incompleteArray) => {
    if(!files || files.length === 0){
        return [];
    }

    let result = []
    let general_settings = JSON.parse(window.sessionStorage.getItem("filetypeGetAll"))

    let promise = new Promise((resolve, reject) => {
        files.forEach((file, index, array) => {
            let settings = general_settings.filetypes.find(object => parseFloat(object.filetype) === parseFloat(file.dossiertypeid))
    
            let indexesToRemove = []
            file.documents.forEach(document => {
                if(document.document){
                    let type = document.document.doctype;
                    let users = settings.doctypes.find(object => object.doctype === type && !object.users.includes(parseFloat(user.role)))
                    if(users){
                        //Remove from documents
                        indexesToRemove.push(file.documents.findIndex(v => v.document && v.document.doctype === users.doctype))           
                    }        
                }                    
            });
    
            function removeObjectsByIndex(objectsArray, indexesArray) {
                return objectsArray.filter((object, index) => !indexesArray.includes(index));
            }
    
            file.documents = removeObjectsByIndex(file.documents, indexesToRemove);
    
            //Check if file is complete
            if(!incompleteArray.includes(parseFloat(file.state))){
                result.push(file)
            } 
    
            if (index === array.length -1) resolve();
        });
    })
    
    return promise.then(()=>{
        return result;
    })
}